// Sends a GA4 "call" event for every tel: link click, site-wide.
export const installCallTracking = () => {
  const onClick = (e: MouseEvent) => {
    const a = (e.target as Element | null)?.closest?.('a[href^="tel:"]') as HTMLAnchorElement | null;
    if (!a) return;
    const phone_number = decodeURIComponent(a.getAttribute("href")!.slice(4));
    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
    w.gtag?.("event", "call", { phone_number });
  };
  document.addEventListener("click", onClick);
  return () => document.removeEventListener("click", onClick);
};
